import {
  FETCH_ALGOS_LIST_REQUEST,
  FETCH_ALGOS_LIST_SUCCESS,
  EMIT,
  ALGOS_LIST_CONFIG_LOADING_START,
  ALGOS_LIST_CONFIG_LOADING_STOP,
  ALGOS_LIST_CONFIG_SELECTED_DAY,
  ALGOS_LIST_CONFIG_SORTING,
  ALGOS_LIST_CONFIG_ERRORS,
  ALGOS_LIST_COMMON_CHANGE,
  ALGOS_LIST_CHANGE_ENABLE,
  ALGOS_LIST_CONFIG_TERMINATE_INIT,
  ALGOS_LIST_CHANGE_MODAL_ERROR,
  ALGOS_LIST_CONFIG_DUPLICATE_ALGO_INIT,
  ALGOS_LIST_CONFIG_RENAME_INIT,
  ALGOS_LIST_CONFIG_DELETE_INIT,
  ALGOS_LIST_CHANGE_DELETE_ALGO,
  ALGOS_LIST_COMMON_UPPEND_DATA,
  ALGOS_LIST_CHANGE_SELECT,
  ALGOS_LIST_CONFIG_FILTER,
  ALGOS_LIST_CHANGE_CLEAR_ALL_SELECT,
  ALGOS_LIST_CHANGE_BULK_SELECT,
  ALGOS_LIST_CONFIG_BULK_CLEAR,
  ALGOS_LIST_CONFIG_BULK_DELETE_INIT,
  ALGOS_LIST_CONFIG_BULK_DUPLICATE_INIT,
  ALGOS_LIST_CHANGE_BULK_DELETE_ALGO,
  ALGOS_LIST_CHANGE_BULK_DUPLICATE_ALGO,
  ALGOS_LIST_CONFIG_PAGE_LOADING_TRUE,
  ALGOS_LIST_CONFIG_PAGE_LOADING_FALSE,
  ALGOS_LIST_UPDATE_SKIP_CLEANER,
  ALGOS_LIST_CONFIG_BULK_SQOFF_TERMINATE_INIT,
  ALGOS_LIST_CONFIG_BULK_TERMINATE_INIT,
  ALGOS_LIST_CHANGE_ENABLE_LOADING,
  ALGOS_LIST_CONFIG_SET_TOTAL_PNL_LENGTH,
  ALGOS_LIST_CONFIG_CLIENT_WISE_SQOFF_TERMINATE_INIT,
  ALGOS_LIST_CONFIG_CLIENT_WISE_TERMINATE_INIT,
  ALGOS_LIST_CONFIG_CLIENT_WISE_SET_TARGET_INIT,
  ALGOS_LIST_CONFIG_TOGGLE_CLIENT_ID,
  ALGOS_LIST_CONFIG_BULK_ENABLE_INIT,
  ALGOS_LIST_CHANGE_BULK_ENABLE_ALGO,
  ALGOS_LIST_CHANGE_BULK_CLEAR_SPECIFIC,
  ALGOS_LIST_CONFIG_BULK_DISABLE_INIT,
  ALGOS_LIST_CHANGE_BULK_DISABLE_ALGO,
  ALGOS_LIST_CHANGE_SQOFF_LOADING,
  ALGOS_LIST_CONFIG_TOGGLE_MTM,
  ALGOS_LIST_CONFIG_MULTI_SELECT,
  ALGOS_LIST_CONFIG_SHIFT_PRESSED,
  ALGOS_LIST_CHANGE_SHIFT_SELECT,
  ALGOS_LIST_CHANGE_MULTIPLIER_LOADING,
  ALGOS_LIST_CHANGE_MULTIPLIER,
  ALGOS_LIST_CHANGE_MULTIPLIER_CACHE,
  ALGOS_LIST_CHANGE_MULTIPLIER_RESET,
  ALGOS_LIST_CONFIG_BULK_MULTIPLIER_INIT,
  ALGOS_LIST_CHANGE_BULK_MULTIPLIER,
  ALGOS_LIST_FORCE_UPDATE,
  ALGOS_LIST_CHANGE_BROKER,
  CACHE_ALGOS_LIST,
  ALGOS_LIST_CONFIG_BULK_MTM_MODIFY_INIT,
} from '../../constants/ActionTypes';
import { algos, brokers, setAuthorizationHeader } from '../../api';
import storage from '../../storage';
import {
  getIsAlgosListFetching,
  getToday,
  getFilter,
  getSelectedDay,
  getIsAlgosListRefreshResponse,
  getAlgoRefreshIdsSelectedDay,
} from './getters';
import { getIsAlgosConfig, getIsBrokers } from '../../reducers';
import { ALGO_TABLE_FILTER, ALGO_TABLE_SORT } from '../../constants/cookies';
import { timeoutPromise } from '../../helpers/promises';
import { writeBuffer } from '../../utils';
import {
  bulkActionNotificationModalData,
  formatSetupBrokerlabel,
} from '../../helpers/data-manipulators';
import { filterAlgos } from '../../helpers/algo-list/filter';
import {
  POSITIONAL_TYPE_N_DAYS,
  POSITIONAL_TYPE_NEXT_DAY,
} from '@quantiply/common/constants';

function decorateFullData(data = [], brokersData = []) {
  const formatedData = data.map((d) => {
    const { configurations = {}, broker = '', ...restProps } = d;
    const {
      isWaitAndTradeEnabled = false,
      multiplier,
      startTime,
      endTime,
      tradingType,
      positionalType,
      legs = [],
    } = configurations;

    let tradingTypeFixed = undefined;

    if (positionalType === POSITIONAL_TYPE_NEXT_DAY) {
      tradingTypeFixed = POSITIONAL_TYPE_NEXT_DAY;
    } else if (positionalType === POSITIONAL_TYPE_N_DAYS) {
      tradingTypeFixed = POSITIONAL_TYPE_N_DAYS;
    } else if (tradingType) {
      tradingTypeFixed = tradingType;
    }

    const targetBroker = brokersData.find((b) => b.id === broker) || {};

    const { clientId: brokerClientId = '', brokerInfo = {} } = targetBroker;
    const { displayName: brokerDisplayName = '' } = brokerInfo;

    const transactionTypes = [];
    const underlyings = [];

    legs.forEach((leg) => {
      if (leg?.transactionType) {
        if (!transactionTypes.includes(leg?.transactionType)) {
          transactionTypes.push(leg?.transactionType);
        }
      }

      if (leg?.base) {
        if (!underlyings.includes(leg?.base)) {
          underlyings.push(leg?.base);
        }
      }
    });

    return Object.assign(
      {
        broker,
        brokerClientId,
        brokerDisplayName,
        multiplier,
        startTime,
        endTime,
        tradingType: tradingTypeFixed,
        transactionTypes,
        underlyings,
      },
      {
        ...restProps,
      },
      {
        configurations: {
          isWaitAndTradeEnabled,
        },
      }
    );
  });

  return formatedData;
}

export const pageLoadingStart = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_PAGE_LOADING_TRUE,
  });

  return Promise.resolve();
};

export const pageLoadingStop = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_PAGE_LOADING_FALSE,
  });

  return Promise.resolve();
};

export const fetchAlgosList = () => async (dispatch, getState) => {
  try {
    if (getIsAlgosListFetching(getState())) {
      return Promise.resolve();
    }

    setAuthorizationHeader(storage.getItem('token'));

    dispatch({
      type: FETCH_ALGOS_LIST_REQUEST,
    });

    const data = await algos.getAlgosDayWise();

    dispatch({
      type: FETCH_ALGOS_LIST_SUCCESS,
      data,
    });

    return Promise.resolve();
  } catch (error) {
    dispatch({
      type: ALGOS_LIST_CONFIG_ERRORS,
      data: {
        error,
      },
    });

    return Promise.reject(null);
  }
};

export const fetchAlgosHealthStatus = () => (dispatch, getState) => {
  const selectedAlgos = getAlgoRefreshIdsSelectedDay(getState());

  dispatch({
    type: EMIT,
    payload: {
      method: 'get_health_status',
      data: {
        algos: selectedAlgos,
      },
    },
  });
};

export const subscribeAlgosPositionUpdatesAll = () => (dispatch) => {
  dispatch({
    type: EMIT,
    payload: {
      method: 'subscribe_lite_position_updates',
    },
  });

  return Promise.resolve();
};

export const unsubscribeAlgosPositionUpdatesAll = () => (dispatch) => {
  dispatch({
    type: EMIT,
    payload: {
      method: 'unsubscribe_lite_position_updates',
    },
  });

  return Promise.resolve();
};

export const setSelectedDay = () => (dispatch, getState) => {
  const { days: algoConfigDays = [] } = getIsAlgosConfig(getState());
  const today = getToday(getState());
  const validateAlgoConfigDays = (dayToCheck) =>
    algoConfigDays.find((dd) => dd.day === dayToCheck);

  let selectedDay = null;

  // if today valid date
  if (validateAlgoConfigDays(today) && validateAlgoConfigDays(today).day) {
    selectedDay = today;
  }

  // Check if hash is set
  if (algoConfigDays && algoConfigDays.length && window.location.hash) {
    if (window.location.hash.startsWith('#day=')) {
      const dayFromHash = window.location.hash.replace('#day=', '');
      const validateDayFromHash = validateAlgoConfigDays(dayFromHash);

      if (validateDayFromHash && validateDayFromHash.day) {
        selectedDay = validateDayFromHash.day;
      }
    }
  }

  // set first value in algoConfigDays as base value if no value added
  if (algoConfigDays && algoConfigDays.length && selectedDay === null) {
    selectedDay = algoConfigDays[0].day;
  }

  dispatch({
    type: ALGOS_LIST_CONFIG_SELECTED_DAY,
    data: selectedDay,
  });

  return Promise.resolve();
};

export const selectAlgo = (id) => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CHANGE_SELECT,
    data: {
      id,
    },
  });

  return Promise.resolve();
};

export const bulkSelectAlgo = (value) => (dispatch, getState) => {
  const day = getSelectedDay(getState());
  dispatch({
    type: ALGOS_LIST_CHANGE_BULK_SELECT,
    data: {
      value,
      day,
    },
  });

  return Promise.resolve();
};

export const changeSelectedDay = (day) => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_SELECTED_DAY,
    data: day,
  });

  window.location.hash = `#day=${day}`;

  dispatch({
    type: ALGOS_LIST_CHANGE_CLEAR_ALL_SELECT,
  });

  return Promise.resolve();
};

export const startLoading = () => async (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_LOADING_START,
  });

  return Promise.resolve();
};

export const stopLoading = () => async (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_LOADING_STOP,
  });

  return Promise.resolve();
};

export const changeSort = (field) => (dispatch) => {
  let newSort = {};
  const cacheSort = storage.getItem(ALGO_TABLE_SORT);

  if (!cacheSort.field || (cacheSort.field && cacheSort.field !== field)) {
    newSort = {
      field,
      order: 'ASC',
    };
  } else if (cacheSort.field === field && cacheSort.order === 'ASC') {
    newSort = {
      field,
      order: 'DSC',
    };
  }

  if (newSort.field && newSort.order) {
    storage.setItems({
      [ALGO_TABLE_SORT]: newSort,
    });
  } else {
    storage.deleteItem(ALGO_TABLE_SORT);
  }

  dispatch({
    type: ALGOS_LIST_CONFIG_SORTING,
    data: newSort,
  });

  return Promise.resolve();
};

export const clearSort = () => (dispatch) => {
  storage.deleteItem(ALGO_TABLE_SORT);

  dispatch({
    type: ALGOS_LIST_CONFIG_SORTING,
    data: {},
  });

  return Promise.resolve();
};

export const algoBrokerChange = (id, broker) => async (dispatch, getState) => {
  try {
    const brokersData = getIsBrokers(getState());
    setAuthorizationHeader(storage.getItem('token'));

    const res = await algos.updateBroker(id, broker);
    const data = res && res.data && res.data.data ? res.data.data : null;

    if (data._id) {
      const fullData = decorateFullData([data], brokersData);

      dispatch({
        type: ALGOS_LIST_CHANGE_BROKER,
        data: {
          id: data._id,
          upadtedData: fullData[0],
        },
      });
    }

    return Promise.resolve();
  } catch (error) {
    dispatch({
      type: ALGOS_LIST_CONFIG_ERRORS,
      data: {
        error,
      },
    });

    console.log(!Object.keys(error.response.data.errors).length);

    if (
      error &&
      error.response &&
      error.response.data &&
      // !Object.keys(error.response.data.errors).length &&
      error.response.data.message &&
      error.response.data.message.trim() !== ''
    ) {
      const err =
        error && error.response && error.response.data
          ? error.response.data
          : {};

      dispatch({
        type: ALGOS_LIST_CHANGE_MODAL_ERROR,
        data: {
          showError: true,
          error: err,
        },
      });

      return Promise.reject(null);
    }

    return Promise.reject(error);
  }
};

export const toggleAlgo =
  (id, toggleCondition = false) =>
  async (dispatch) => {
    try {
      dispatch({
        type: ALGOS_LIST_CHANGE_ENABLE_LOADING,
        data: {
          id,
          loading: true,
        },
      });

      await timeoutPromise(200);

      const toggle = toggleCondition ? 'enable' : 'disable';
      setAuthorizationHeader(storage.getItem('token'));
      const res = await algos.toggleAlgo(id, toggle);
      const isSuccess =
        res && res.data && res.data.status && res.data.status === 'success'
          ? true
          : false;

      if (isSuccess) {
        dispatch({
          type: ALGOS_LIST_CHANGE_ENABLE,
          data: {
            id,
            enabled: toggleCondition,
          },
        });
      }

      await timeoutPromise(500);

      return Promise.resolve({
        isSuccess,
        enabled: toggleCondition,
      });
    } catch (error) {
      dispatch({
        type: ALGOS_LIST_CONFIG_ERRORS,
        data: {
          error,
        },
      });

      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message &&
        error.response.data.message.trim() !== ''
      ) {
        const err =
          error && error.response && error.response.data
            ? error.response.data
            : {};

        dispatch({
          type: ALGOS_LIST_CHANGE_MODAL_ERROR,
          data: {
            showError: true,
            error: err,
          },
        });

        return Promise.reject(null);
      }

      return Promise.reject(error);
    } finally {
      dispatch({
        type: ALGOS_LIST_CHANGE_ENABLE_LOADING,
        data: {
          id,
          loading: false,
        },
      });
    }
  };

export const clearModalErrors = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CHANGE_MODAL_ERROR,
    data: {
      showError: false,
      error: {},
    },
  });

  return Promise.resolve();
};

export const terminateAlgoStart =
  ({ action, algoId }) =>
  (dispatch) => {
    dispatch({
      type: ALGOS_LIST_CONFIG_TERMINATE_INIT,
      data: {
        start: true,
        action,
        algoId,
      },
    });

    return Promise.resolve();
  };

export const terminateAlgoClear = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_TERMINATE_INIT,
    data: {
      start: false,
      action: '',
      algoId: '',
    },
  });

  return Promise.resolve();
};

export const sqOffAll = (id) => async (dispatch) => {
  try {
    dispatch({
      type: ALGOS_LIST_CHANGE_SQOFF_LOADING,
      data: {
        id,
        loading: true,
      },
    });

    setAuthorizationHeader(storage.getItem('token'));
    await algos.sqOffAll(id);

    return Promise.resolve();
  } catch (error) {
    dispatch({
      type: ALGOS_LIST_CONFIG_ERRORS,
      data: {
        error,
      },
    });

    return Promise.reject(error);
  } finally {
    dispatch({
      type: ALGOS_LIST_CHANGE_SQOFF_LOADING,
      data: {
        id,
        loading: false,
      },
    });
  }
};

export const terminate = (id) => async (dispatch) => {
  try {
    dispatch({
      type: ALGOS_LIST_CHANGE_SQOFF_LOADING,
      data: {
        id,
        loading: true,
      },
    });

    setAuthorizationHeader(storage.getItem('token'));
    await algos.terminate(id);
    return Promise.resolve();
  } catch (error) {
    dispatch({
      type: ALGOS_LIST_CONFIG_ERRORS,
      data: {
        error,
      },
    });
    return Promise.reject(error);
  } finally {
    dispatch({
      type: ALGOS_LIST_CHANGE_SQOFF_LOADING,
      data: {
        id,
        loading: false,
      },
    });
  }
};

export const duplicateAlgoStart =
  (id, name, day, broker, type) => (dispatch) => {
    dispatch({
      type: ALGOS_LIST_CONFIG_DUPLICATE_ALGO_INIT,
      data: {
        start: true,
        id,
        name,
        day,
        broker,
        type,
      },
    });

    return Promise.resolve();
  };

export const duplicateAlgoClear = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_DUPLICATE_ALGO_INIT,
    data: {
      start: false,
      id: '',
      name: '',
      day: '',
      broker: '',
    },
  });

  return Promise.resolve();
};

export const duplicateAlgo =
  (id, name, day, broker, type) => async (dispatch, getState) => {
    try {
      const brokersData = getIsBrokers(getState());
      setAuthorizationHeader(storage.getItem('token'));

      const res = await algos.duplicateAlgo(id, name, day, broker, type);

      const data = res && res.data && res.data.data ? res.data.data : [];

      const fullData = decorateFullData(data, brokersData);

      dispatch({
        type: ALGOS_LIST_COMMON_UPPEND_DATA,
        data: {
          fullData,
        },
      });

      return Promise.resolve();
    } catch (error) {
      dispatch({
        type: ALGOS_LIST_CONFIG_ERRORS,
        data: {
          error,
        },
      });
      return Promise.reject(error);
    }
  };

export const renameAlgoStart = (id, name) => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_RENAME_INIT,
    data: {
      start: true,
      id,
      name,
    },
  });

  return Promise.resolve();
};

export const renameAlgoClear = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_RENAME_INIT,
    data: {
      start: false,
      id: '',
      name: '',
    },
  });

  return Promise.resolve();
};

export const renameAlgo = (id, name) => async (dispatch) => {
  try {
    setAuthorizationHeader(storage.getItem('token'));

    const res = await algos.renameAlgo(id, name);
    const data = res && res.data && res.data.data ? res.data.data : null;

    if (data._id) {
      dispatch({
        type: ALGOS_LIST_COMMON_CHANGE,
        data: {
          fullData: data,
        },
      });
    }

    return Promise.resolve();
  } catch (error) {
    dispatch({
      type: ALGOS_LIST_CONFIG_ERRORS,
      data: {
        error,
      },
    });
    return Promise.reject(error);
  }
};

export const deleteAlgoStart = (id) => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_DELETE_INIT,
    data: {
      start: true,
      id,
    },
  });

  return Promise.resolve();
};

export const deleteAlgoClear = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_DELETE_INIT,
    data: {
      start: false,
      id: '',
    },
  });

  return Promise.resolve();
};

export const deleteAlgo = (id) => async (dispatch) => {
  try {
    setAuthorizationHeader(storage.getItem('token'));

    await algos.deleteAlgo(id);

    dispatch({
      type: ALGOS_LIST_CHANGE_DELETE_ALGO,
      data: {
        id,
      },
    });

    return Promise.resolve();
  } catch (error) {
    dispatch({
      type: ALGOS_LIST_CONFIG_ERRORS,
      data: {
        error,
      },
    });

    if (
      error &&
      error.response &&
      error.response.data &&
      !Object.keys(error.response.data.errors).length &&
      error.response.data.message &&
      error.response.data.message.trim() !== ''
    ) {
      const err =
        error && error.response && error.response.data
          ? error.response.data
          : {};

      dispatch({
        type: ALGOS_LIST_CHANGE_MODAL_ERROR,
        data: {
          showError: true,
          error: err,
        },
      });

      return Promise.reject(null);
    }

    return Promise.reject(error);
  }
};

export const commonDataAppend = (data) => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_COMMON_UPPEND_DATA,
    data: {
      fullData: data,
    },
  });

  return Promise.resolve();
};

export const createAlgo = (name, code, day, broker) => async (dispatch) => {
  try {
    setAuthorizationHeader(storage.getItem('token'));

    const res = await algos.createAlgo(name, code, day, broker);

    const data = res && res.data && res.data.data ? res.data.data : null;

    return Promise.resolve(data);
  } catch (error) {
    dispatch({
      type: ALGOS_LIST_CONFIG_ERRORS,
      data: {
        error,
      },
    });

    return Promise.reject(error);
  }
};

export const updateFilter =
  (filterValues = {}) =>
  (dispatch, getState) => {
    // filterValues = { search: 'term'}

    const filter = getFilter(getState());

    const newFilter = {
      ...filter,
      ...filterValues,
    };

    dispatch({
      type: ALGOS_LIST_CONFIG_FILTER,
      data: newFilter,
    });

    writeBuffer(ALGO_TABLE_FILTER, newFilter);

    return Promise.resolve();
  };

export const updateFilterBroker = (brokerId) => (dispatch, getState) => {
  const filter = getFilter(getState());
  let { brokers = [] } = filter || {};

  if (brokers.includes(brokerId)) {
    brokers = brokers.filter((broker) => broker !== brokerId);
  } else {
    brokers.push(brokerId);
  }

  const newFilter = {
    ...filter,
    brokers,
  };

  dispatch({
    type: ALGOS_LIST_CONFIG_FILTER,
    data: newFilter,
  });

  writeBuffer(ALGO_TABLE_FILTER, newFilter);

  return Promise.resolve();
};

export const bulkDeleteAlgoStart = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_BULK_DELETE_INIT,
    data: {
      start: true,
    },
  });

  return Promise.resolve();
};

export const bulkDeleteAlgoClear = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_BULK_DELETE_INIT,
    data: {
      start: false,
    },
  });

  return Promise.resolve();
};

export const bulkDeleteAlgo =
  (algoIds = []) =>
  async (dispatch) => {
    try {
      setAuthorizationHeader(storage.getItem('token'));

      const res = await algos.bulkActionDelete(algoIds);

      const data = res.data && res.data.data ? res.data.data : [];
      const allClear = data.every((d) => d.success);

      dispatch({
        type: ALGOS_LIST_CHANGE_BULK_DELETE_ALGO,
        data: {
          ids: data.filter((d) => d.success === true) || [],
        },
      });

      if (allClear) {
        return Promise.resolve();
      } else {
        const errorAlgos = data.filter((d) => d.success === false) || [];
        const modalData = bulkActionNotificationModalData(data);

        dispatch({
          type: ALGOS_LIST_CHANGE_MODAL_ERROR,
          data: {
            showError: true,
            error: modalData,
          },
        });

        return Promise.resolve(errorAlgos);
      }
    } catch (error) {
      dispatch({
        type: ALGOS_LIST_CONFIG_ERRORS,
        data: {
          error,
        },
      });

      if (
        error &&
        error.response &&
        error.response.data &&
        !Object.keys(error.response.data.errors).length &&
        error.response.data.message &&
        error.response.data.message.trim() !== ''
      ) {
        const err =
          error && error.response && error.response.data
            ? error.response.data
            : {};

        dispatch({
          type: ALGOS_LIST_CHANGE_MODAL_ERROR,
          data: {
            showError: true,
            error: err,
          },
        });

        return Promise.reject(null);
      }

      return Promise.reject(error);
    } finally {
      dispatch({
        type: ALGOS_LIST_CHANGE_CLEAR_ALL_SELECT,
      });

      dispatch({
        type: ALGOS_LIST_CONFIG_BULK_CLEAR,
      });
    }
  };

export const bulkDuplicateAlgoStart = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_BULK_DUPLICATE_INIT,
    data: {
      start: true,
    },
  });

  return Promise.resolve();
};

export const bulkDuplicateAlgoClear = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_BULK_DUPLICATE_INIT,
    data: {
      start: false,
    },
  });

  return Promise.resolve();
};

export const bulkDuplicateAlgo =
  ({ cloneOf, day, addText, addTextType, broker, type }) =>
  async (dispatch) => {
    try {
      setAuthorizationHeader(storage.getItem('token'));

      const options = {
        cloneOf,
        day,
        addText,
        addTextType,
      };

      if (broker) {
        options.broker = broker;
      }

      if (type) {
        options.type = type;
      }

      const res = await algos.bulkActionClone(options);

      const data = res.data && res.data.data ? res.data.data : [];
      const allClear = data.every((d) => d.success);

      dispatch({
        type: ALGOS_LIST_CHANGE_BULK_DUPLICATE_ALGO,
        data: {
          ids: data.filter((d) => d.success === true) || [],
        },
      });

      if (allClear) {
        return Promise.resolve();
      } else {
        const errorAlgos = data.filter((d) => d.success === false) || [];
        const modalData = bulkActionNotificationModalData(data);

        dispatch({
          type: ALGOS_LIST_CHANGE_MODAL_ERROR,
          data: {
            showError: true,
            error: modalData,
          },
        });

        return Promise.resolve(errorAlgos);
      }
    } catch (error) {
      dispatch({
        type: ALGOS_LIST_CONFIG_ERRORS,
        data: {
          error,
        },
      });

      if (
        error &&
        error.response &&
        error.response.data &&
        !Object.keys(error.response.data.errors).length &&
        error.response.data.message &&
        error.response.data.message.trim() !== ''
      ) {
        const err =
          error && error.response && error.response.data
            ? error.response.data
            : {};

        dispatch({
          type: ALGOS_LIST_CHANGE_MODAL_ERROR,
          data: {
            showError: true,
            error: err,
          },
        });

        return Promise.reject(null);
      }

      return Promise.reject(error);
    } finally {
      dispatch({
        type: ALGOS_LIST_CHANGE_CLEAR_ALL_SELECT,
      });

      dispatch({
        type: ALGOS_LIST_CONFIG_BULK_CLEAR,
      });
    }
  };

export const updateSkipCleaner = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_UPDATE_SKIP_CLEANER,
  });

  return Promise.resolve();
};

export const bulkTerminateAlgoStart = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_BULK_TERMINATE_INIT,
    data: {
      start: true,
    },
  });

  return Promise.resolve();
};

export const bulkTerminateAlgoClear = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_BULK_TERMINATE_INIT,
    data: {
      start: false,
    },
  });

  return Promise.resolve();
};

export const bulkTerminateAlgo =
  (algoIds = []) =>
  async (dispatch) => {
    try {
      setAuthorizationHeader(storage.getItem('token'));

      const res = await algos.bulkActionTerminate(algoIds);

      const data = res.data && res.data.data ? res.data.data : [];
      const allClear = data.every((d) => d.success);

      if (allClear) {
        return Promise.resolve();
      } else {
        const errorAlgos = data.filter((d) => d.success === false) || [];
        const modalData = bulkActionNotificationModalData(data);

        dispatch({
          type: ALGOS_LIST_CHANGE_MODAL_ERROR,
          data: {
            showError: true,
            error: modalData,
          },
        });

        return Promise.resolve(errorAlgos);
      }
    } catch (error) {
      dispatch({
        type: ALGOS_LIST_CONFIG_ERRORS,
        data: {
          error,
        },
      });

      if (
        error &&
        error.response &&
        error.response.data &&
        !Object.keys(error.response.data.errors).length &&
        error.response.data.message &&
        error.response.data.message.trim() !== ''
      ) {
        const err =
          error && error.response && error.response.data
            ? error.response.data
            : {};

        dispatch({
          type: ALGOS_LIST_CHANGE_MODAL_ERROR,
          data: {
            showError: true,
            error: err,
          },
        });

        return Promise.reject(null);
      }

      return Promise.reject(error);
    } finally {
      dispatch({
        type: ALGOS_LIST_CHANGE_CLEAR_ALL_SELECT,
      });

      dispatch({
        type: ALGOS_LIST_CONFIG_BULK_CLEAR,
      });
    }
  };

export const bulkSqOffTerminateAlgoStart = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_BULK_SQOFF_TERMINATE_INIT,
    data: {
      start: true,
    },
  });

  return Promise.resolve();
};

export const bulkSqOffTerminateAlgoClear = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_BULK_SQOFF_TERMINATE_INIT,
    data: {
      start: false,
    },
  });

  return Promise.resolve();
};

export const bulkSqOffTerminateAlgo =
  (algoIds = []) =>
  async (dispatch) => {
    try {
      setAuthorizationHeader(storage.getItem('token'));

      const res = await algos.bulkActionSquareOffTerminate(algoIds);

      const data = res.data && res.data.data ? res.data.data : [];
      const allClear = data.every((d) => d.success);

      if (allClear) {
        return Promise.resolve();
      } else {
        const errorAlgos = data.filter((d) => d.success === false) || [];
        const modalData = bulkActionNotificationModalData(data);

        dispatch({
          type: ALGOS_LIST_CHANGE_MODAL_ERROR,
          data: {
            showError: true,
            error: modalData,
          },
        });

        return Promise.resolve(errorAlgos);
      }
    } catch (error) {
      dispatch({
        type: ALGOS_LIST_CONFIG_ERRORS,
        data: {
          error,
        },
      });

      if (
        error &&
        error.response &&
        error.response.data &&
        !Object.keys(error.response.data.errors).length &&
        error.response.data.message &&
        error.response.data.message.trim() !== ''
      ) {
        const err =
          error && error.response && error.response.data
            ? error.response.data
            : {};

        dispatch({
          type: ALGOS_LIST_CHANGE_MODAL_ERROR,
          data: {
            showError: true,
            error: err,
          },
        });

        return Promise.reject(null);
      }

      return Promise.reject(error);
    } finally {
      dispatch({
        type: ALGOS_LIST_CHANGE_CLEAR_ALL_SELECT,
      });

      dispatch({
        type: ALGOS_LIST_CONFIG_BULK_CLEAR,
      });
    }
  };

export const setTotalPnlLength = (value) => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_SET_TOTAL_PNL_LENGTH,
    value: value,
  });

  return Promise.resolve();
};

export const clientWiseSqOffTerminateAlgoStart = (brokerId) => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_CLIENT_WISE_SQOFF_TERMINATE_INIT,
    data: {
      start: true,
      brokerId,
    },
  });

  return Promise.resolve();
};

export const clientWiseSqOffTerminateAlgoClear = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_CLIENT_WISE_SQOFF_TERMINATE_INIT,
    data: {
      start: false,
      brokerId: '',
    },
  });

  return Promise.resolve();
};

export const clientWiseSqOffTerminateAlgo = (brokerId) => async (dispatch) => {
  try {
    setAuthorizationHeader(storage.getItem('token'));

    const res = await algos.clientWiseSqOffTerminate(brokerId);

    const data = res.data && res.data.data ? res.data.data : [];
    const allClear = data.every((d) => d.success);

    if (allClear) {
      return Promise.resolve();
    } else {
      const errorAlgos = data.filter((d) => d.success === false) || [];
      const modalData = bulkActionNotificationModalData(data);

      dispatch({
        type: ALGOS_LIST_CHANGE_MODAL_ERROR,
        data: {
          showError: true,
          error: modalData,
        },
      });

      return Promise.resolve(errorAlgos);
    }
  } catch (error) {
    dispatch({
      type: ALGOS_LIST_CONFIG_ERRORS,
      data: {
        error,
      },
    });

    if (
      error &&
      error.response &&
      error.response.data &&
      !Object.keys(error.response.data.errors).length &&
      error.response.data.message &&
      error.response.data.message.trim() !== ''
    ) {
      const err =
        error && error.response && error.response.data
          ? error.response.data
          : {};

      dispatch({
        type: ALGOS_LIST_CHANGE_MODAL_ERROR,
        data: {
          showError: true,
          error: err,
        },
      });

      return Promise.reject(null);
    }

    return Promise.reject(error);
  }
};

export const clientWiseTerminateAlgoStart =
  (brokerId = '') =>
  (dispatch) => {
    dispatch({
      type: ALGOS_LIST_CONFIG_CLIENT_WISE_TERMINATE_INIT,
      data: {
        start: true,
        brokerId,
      },
    });

    return Promise.resolve();
  };

export const clientWiseTerminateAlgoClear = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_CLIENT_WISE_TERMINATE_INIT,
    data: {
      start: false,
      brokerId: '',
    },
  });

  return Promise.resolve();
};

export const clientWiseTerminateAlgo = (brokerId) => async (dispatch) => {
  try {
    setAuthorizationHeader(storage.getItem('token'));

    const res = await algos.clientWiseTerminate(brokerId);

    const data = res.data && res.data.data ? res.data.data : [];
    const allClear = data.every((d) => d.success);

    if (allClear) {
      return Promise.resolve();
    } else {
      const errorAlgos = data.filter((d) => d.success === false) || [];
      const modalData = bulkActionNotificationModalData(data);

      dispatch({
        type: ALGOS_LIST_CHANGE_MODAL_ERROR,
        data: {
          showError: true,
          error: modalData,
        },
      });

      return Promise.resolve(errorAlgos);
    }
  } catch (error) {
    dispatch({
      type: ALGOS_LIST_CONFIG_ERRORS,
      data: {
        error,
      },
    });

    if (
      error &&
      error.response &&
      error.response.data &&
      !Object.keys(error.response.data.errors).length &&
      error.response.data.message &&
      error.response.data.message.trim() !== ''
    ) {
      const err =
        error && error.response && error.response.data
          ? error.response.data
          : {};

      dispatch({
        type: ALGOS_LIST_CHANGE_MODAL_ERROR,
        data: {
          showError: true,
          error: err,
        },
      });

      return Promise.reject(null);
    }

    return Promise.reject(error);
  }
};

export const clientWiseSetTargetStart =
  ({
    brokerId,
    stoploss,
    target,
    trailingStoploss,
    lockProfit,
    trailProfit,
    lockTrailProfit,
    trailingInterval,
  }) =>
  (dispatch) => {
    dispatch({
      type: ALGOS_LIST_CONFIG_CLIENT_WISE_SET_TARGET_INIT,
      data: {
        start: true,
        brokerId,
        stoploss: stoploss ? Math.abs(stoploss) : stoploss,
        target,
        trailingStoploss,
        lockProfit,
        trailProfit,
        lockTrailProfit,
        trailingInterval,
      },
    });

    return Promise.resolve();
  };

export const clientWiseSetTargetClear = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_CLIENT_WISE_SET_TARGET_INIT,
    data: {
      start: false,
      brokerId: 0,
      stoploss: 0,
      target: 0,
      trailingStoploss: undefined,
      lockProfit: undefined,
      trailProfit: undefined,
      lockTrailProfit: undefined,
      trailingInterval: undefined,
    },
  });

  return Promise.resolve();
};

export const clientWiseSetTarget =
  (
    brokerId,
    {
      stoploss,
      target,
      trailingStoplossType,
      tailingStoplossValues = {},
      trailingInterval,
    }
  ) =>
  async () => {
    try {
      setAuthorizationHeader(storage.getItem('token'));

      let data = {
        stoploss: stoploss ? -Math.abs(stoploss) : stoploss,
        target,
      };

      switch (trailingStoplossType) {
        case 'trailingStoploss':
          data.trailingStoploss = tailingStoplossValues;
          break;
        case 'lockProfit':
          data.lockProfit = tailingStoplossValues;
          break;
        case 'trailProfit':
          data.trailProfit = tailingStoplossValues;
          break;
        case 'lockTrailProfit':
          data.lockTrailProfit = tailingStoplossValues;
          break;
        default:
          break;
      }

      if (trailingStoplossType && trailingStoplossType !== 'none') {
        data.trailingInterval = trailingInterval;
      }

      await brokers.clientWiseSetTarget(brokerId, data);

      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  };

export const toggleBrokerDataClientId = () => async (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_TOGGLE_CLIENT_ID,
  });

  return Promise.resolve();
};

export const toggleDataMtmShow = () => async (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_TOGGLE_MTM,
  });

  return Promise.resolve();
};

export const bulkEnableAlgoStart = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_BULK_ENABLE_INIT,
    data: {
      start: true,
    },
  });

  return Promise.resolve();
};

export const bulkEnableAlgoClear = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_BULK_ENABLE_INIT,
    data: {
      start: false,
    },
  });

  return Promise.resolve();
};

export const bulkDisableAlgoStart = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_BULK_DISABLE_INIT,
    data: {
      start: true,
    },
  });

  return Promise.resolve();
};

export const bulkDisableAlgoClear = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_BULK_DISABLE_INIT,
    data: {
      start: false,
    },
  });

  return Promise.resolve();
};

export const bulkEnableDisableAlgo =
  (algoIds = [], action = 'enable') =>
  async (dispatch) => {
    try {
      setAuthorizationHeader(storage.getItem('token'));

      const res =
        action === 'enable'
          ? await algos.bulkActionEnable(algoIds)
          : await algos.bulkActionDisable(algoIds);

      const data = res.data && res.data.data ? res.data.data : [];
      const successIds = data
        .filter((d) => d.success === true)
        .map((e) => e.id);
      const errorIds = data.filter((d) => d.success === false).map((e) => e.id);
      const allClear = data.every((d) => d.success);

      dispatch({
        type:
          action === 'enable'
            ? ALGOS_LIST_CHANGE_BULK_ENABLE_ALGO
            : ALGOS_LIST_CHANGE_BULK_DISABLE_ALGO,
        data: {
          ids: data,
        },
      });

      if (!allClear) {
        // if some have errors
        const modalData = bulkActionNotificationModalData(data);

        dispatch({
          type: ALGOS_LIST_CHANGE_MODAL_ERROR,
          data: {
            showError: true,
            error: modalData,
          },
        });
      }

      return Promise.resolve({
        successIds,
        errorIds,
        allClear,
      });
    } catch (error) {
      dispatch({
        type: ALGOS_LIST_CONFIG_ERRORS,
        data: {
          error,
        },
      });

      dispatch({
        type: ALGOS_LIST_CHANGE_BULK_CLEAR_SPECIFIC,
        data: {
          algoIds,
        },
      });

      if (
        error &&
        error.response &&
        error.response.data &&
        !Object.keys(error.response.data.errors).length &&
        error.response.data.message &&
        error.response.data.message.trim() !== ''
      ) {
        const err =
          error && error.response && error.response.data
            ? error.response.data
            : {};

        dispatch({
          type: ALGOS_LIST_CHANGE_MODAL_ERROR,
          data: {
            showError: true,
            error: err,
          },
        });

        return Promise.reject(null);
      }

      return Promise.reject(error);
    }
  };

export const shiftSelectAlgo =
  (ids, selected = false) =>
  (dispatch, getState) => {
    const day = getSelectedDay(getState());
    dispatch({
      type: ALGOS_LIST_CHANGE_SHIFT_SELECT,
      data: {
        ids,
        selected,
        day,
      },
    });

    return Promise.resolve();
  };

export const multiSelect = (id) => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_MULTI_SELECT,
    data: {
      id,
    },
  });

  return Promise.resolve();
};

export const multiSelectClear = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_MULTI_SELECT,
    data: {
      id: '',
    },
  });

  return Promise.resolve();
};

export const checkboxShiftPress =
  (data = false) =>
  (dispatch) => {
    dispatch({
      type: ALGOS_LIST_CONFIG_SHIFT_PRESSED,
      data,
    });

    return Promise.resolve();
  };

export const updateMultiplierReset = () => async (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CHANGE_MULTIPLIER_RESET,
  });
};

export const updateMultiplierCache = (id, multiplier) => async (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CHANGE_MULTIPLIER_CACHE,
    data: {
      id,
      multiplier,
    },
  });
};

export const updateMultiplier = (id, multiplier) => async (dispatch) => {
  try {
    dispatch({
      type: ALGOS_LIST_CHANGE_MULTIPLIER_LOADING,
      data: {
        id,
        loading: true,
      },
    });

    await timeoutPromise(100);

    setAuthorizationHeader(storage.getItem('token'));

    const res = await algos.updateMultiplier(id, multiplier);
    const data = res.data && res.data.data ? res.data.data : [];

    const allClear = data.every((d) => d.success);

    if (allClear) {
      dispatch({
        type: ALGOS_LIST_CHANGE_MULTIPLIER,
        data: {
          id,
          multiplier,
        },
      });

      await timeoutPromise(200);

      dispatch({
        type: ALGOS_LIST_FORCE_UPDATE,
      });

      return Promise.resolve({
        isSuccess: allClear,
        multiplier,
      });
    } else {
      const modalData = bulkActionNotificationModalData(data);

      dispatch({
        type: ALGOS_LIST_CHANGE_MODAL_ERROR,
        data: {
          showError: true,
          error: modalData,
        },
      });

      return Promise.reject(null);
    }
  } catch (error) {
    dispatch({
      type: ALGOS_LIST_CONFIG_ERRORS,
      data: {
        error,
      },
    });

    if (
      error &&
      error.response &&
      error.response.data &&
      !Object.keys(error.response.data.errors).length &&
      error.response.data.message &&
      error.response.data.message.trim() !== ''
    ) {
      const err =
        error && error.response && error.response.data
          ? error.response.data
          : {};

      dispatch({
        type: ALGOS_LIST_CHANGE_MODAL_ERROR,
        data: {
          showError: true,
          error: err,
        },
      });

      return Promise.reject(null);
    }

    return Promise.reject(error);
  } finally {
    dispatch({
      type: ALGOS_LIST_CHANGE_MULTIPLIER_LOADING,
      data: {
        id,
        loading: false,
      },
    });
  }
};

export const bulkUpdateMultiplier =
  (algoMultiplierIds = []) =>
  async (dispatch) => {
    try {
      const algoIds = algoMultiplierIds.map((d) => d._id);
      setAuthorizationHeader(storage.getItem('token'));

      const res = await algos.bulkActionDelete(algoIds);

      const data = res.data && res.data.data ? res.data.data : [];
      const allClear = data.every((d) => d.success);

      dispatch({
        type: ALGOS_LIST_CHANGE_BULK_DELETE_ALGO,
        data: {
          ids: data.filter((d) => d.success === true) || [],
        },
      });

      if (allClear) {
        return Promise.resolve();
      } else {
        const errorAlgos = data.filter((d) => d.success === false) || [];
        const modalData = bulkActionNotificationModalData(data);

        dispatch({
          type: ALGOS_LIST_CHANGE_MODAL_ERROR,
          data: {
            showError: true,
            error: modalData,
          },
        });

        return Promise.resolve(errorAlgos);
      }
    } catch (error) {
      dispatch({
        type: ALGOS_LIST_CONFIG_ERRORS,
        data: {
          error,
        },
      });

      if (
        error &&
        error.response &&
        error.response.data &&
        !Object.keys(error.response.data.errors).length &&
        error.response.data.message &&
        error.response.data.message.trim() !== ''
      ) {
        const err =
          error && error.response && error.response.data
            ? error.response.data
            : {};

        dispatch({
          type: ALGOS_LIST_CHANGE_MODAL_ERROR,
          data: {
            showError: true,
            error: err,
          },
        });

        return Promise.reject(null);
      }

      return Promise.reject(error);
    } finally {
      dispatch({
        type: ALGOS_LIST_CHANGE_CLEAR_ALL_SELECT,
      });

      dispatch({
        type: ALGOS_LIST_CONFIG_BULK_CLEAR,
      });
    }
  };

export const bulkMultiplierAlgoStart = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_BULK_MULTIPLIER_INIT,
    data: {
      start: true,
    },
  });

  return Promise.resolve();
};

export const bulkMultiplierAlgoClear = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_BULK_MULTIPLIER_INIT,
    data: {
      start: false,
    },
  });

  return Promise.resolve();
};

export const bulkMultiplierAlgo =
  (algoIds = [], value) =>
  async (dispatch) => {
    try {
      setAuthorizationHeader(storage.getItem('token'));

      const res = await algos.bulkUpdateMultiplier(algoIds, value);

      const data = res.data && res.data.data ? res.data.data : [];
      const successIds = data
        .filter((d) => d.success === true)
        .map((e) => e.id);
      const errorIds = data.filter((d) => d.success === false).map((e) => e.id);
      const allClear = data.every((d) => d.success);

      dispatch({
        type: ALGOS_LIST_CHANGE_BULK_MULTIPLIER,
        data: {
          ids: data,
          value: value,
        },
      });

      if (!allClear) {
        // if some have errors
        const modalData = bulkActionNotificationModalData(data);

        dispatch({
          type: ALGOS_LIST_CHANGE_MODAL_ERROR,
          data: {
            showError: true,
            error: modalData,
          },
        });
      }

      return Promise.resolve({
        successIds,
        errorIds,
        allClear,
      });
    } catch (error) {
      dispatch({
        type: ALGOS_LIST_CONFIG_ERRORS,
        data: {
          error,
        },
      });

      dispatch({
        type: ALGOS_LIST_CHANGE_BULK_CLEAR_SPECIFIC,
        data: {
          algoIds,
        },
      });

      if (
        error &&
        error.response &&
        error.response.data &&
        !Object.keys(error.response.data.errors).length &&
        error.response.data.message &&
        error.response.data.message.trim() !== ''
      ) {
        const err =
          error && error.response && error.response.data
            ? error.response.data
            : {};

        dispatch({
          type: ALGOS_LIST_CHANGE_MODAL_ERROR,
          data: {
            showError: true,
            error: err,
          },
        });

        return Promise.reject(null);
      }

      return Promise.reject(error);
    }
  };

//

export const bulkMTMModifyAlgoStart = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_BULK_MTM_MODIFY_INIT,
    data: {
      start: true,
    },
  });

  return Promise.resolve();
};

export const bulkMTMModifyAlgoClear = () => (dispatch) => {
  dispatch({
    type: ALGOS_LIST_CONFIG_BULK_MTM_MODIFY_INIT,
    data: {
      start: false,
    },
  });

  return Promise.resolve();
};

export const bulkMTMModifyAlgo =
  (algoIds = [], action, factor) =>
  async (dispatch) => {
    try {
      setAuthorizationHeader(storage.getItem('token'));

      const res = await algos.bulkUpdateMTMModify(algoIds, action, factor);
      const message = res?.data?.data?.message || undefined;

      return Promise.resolve(message);
    } catch (error) {
      return Promise.reject(error);
    } finally {
      dispatch({
        type: ALGOS_LIST_CHANGE_BULK_CLEAR_SPECIFIC,
        data: {
          algoIds,
        },
      });
    }
  };

export const cacheAlgosList = () => async (dispatch, getState) => {
  await timeoutPromise(50);
  const { data: algoDaysData = [], ...restProps } =
    getIsAlgosListRefreshResponse(getState());
  const brokers = getIsBrokers(getState());
  const brokersDataAll = brokers.map((b) => ({
    label: formatSetupBrokerlabel(b),
    value: b.id,
    brokerDisabled: b.status && b.status === 'disabled' ? true : false,
  }));

  const cachedData = {
    ...restProps,
  };

  const filter = getFilter(getState());

  for (let index = 0; index < algoDaysData.length; index++) {
    const dayData = algoDaysData[index];

    const algosFiltered = filterAlgos(
      dayData.algos || [],
      filter,
      brokersDataAll
    );

    // make copy to avoid modifying algo refresh
    const updatedAlgo = {
      ...dayData,
      algos: algosFiltered,
    };

    // add data if no data
    if (!cachedData.data) {
      cachedData.data = [];
    }

    cachedData.data.push(updatedAlgo);
  }

  dispatch({
    type: CACHE_ALGOS_LIST,
    data: cachedData,
  });

  return Promise.resolve();
};
